import Vue from 'vue'
import Vuex from 'vuex'
import addbuy from './modules/addBuy'
import newbuy from './modules/newBuy'
import renewbuy from './modules/renewBuy'
import Order from './modules/Order'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        subnav: [],
        yunVarity: [],
        lessonVarity: [],
        orderInfo: null,
        otherOrderId: '',
        globalTabType: '',
        curTabInstance: null,
        seats: '',
        wh10ClientAccount: '',
        isclient: false, //todo: 用于判断是否是客户端通过url访问进来的
        payOk: false, //用于判断上一次或者正在进行的支付环节是否成功
        pImgUrlList: [],
        softUrl: null,
        inIframe: false
    },
    mutations: {
        setInIframe (state, payload) {
            state.inIframe =  payload
        },
        setOrderInfo(state, payload) {
            state.orderInfo = payload
        },
        setOtherId (state, payload) {
            state.otherOrderId = payload
        },
        setSubNav(state, payload) {
            state.subnav = payload
        },
        setSeats (state,val) {
            state.seats = val
        },
        setYunVarity(state, payload) {
            state.yunVarity = payload
        },
        setLessonVarity(state, payload) {
            state.lessonVarity = payload
        },
        setGlobalTabType (state,val) {
            state.globalTabType = val
        },
        setTabInstance (state,val) {
            state.curTabInstance = val
        },
        setWh10ClientAccount(state,val) {
            state.wh10ClientAccount = val
        },
        setIsClient (state,val) {
            state.isclient = val
        },
        setPayState (state, val) {
            state.payOk = val
        },
        setPic(state, payload) {
            state.pImgUrlList = payload
        },
        setProductAddress(state, payload) {
            state.softUrl = payload
        },
    },
    getters: {
        subnavNames(state) {
            var arr = []
            for (let i = 0; i < state.subnav.length; i++) {
                let v = state.subnav[i]
                if (typeof v == 'string') {
                    arr.push(v)
                } else {
                    // 2024-9-3
                    // 运营部 - 3 - 柏慧（客户运营）(baih) 16:29:45
                    // 这块能加一级 培训课程吗
                    // 运营部 - 3 - 柏慧（客户运营）(baih) 16:49:06
                    // 要是导航也加，能简单点吗
                    // 开发四部 - 1 - 王雷(wanglei) 16:49:50
                    // 目前不一定，因为导航这块上一版修改是袁照做的，我得和李磊研究下当时导航改成了什么逻辑
                    // 开发四部 - 1 - 王雷(wanglei) 16:51:07
                    // 反正，如果要加的话，怎么都会麻烦一些，但是如果想要后台不加，只是前端加个文字的话，我可以看看能不能做个判断，在前端写死，但是这样很可能导致以后有bug，查起来还麻烦
                    // 开发四部 - 1 - 王雷(wanglei) 17:03:21
                    // 我刚才分析了下代码逻辑，这块如果想要单独加这个文字的话，只能我前端写死，李磊那没法改，但是写死的话，涉及到多个后台id，一旦这些id发生变化，或者业务下线等因素，导致id冲突，就会很容易产生bug，看你那是不是非常需要这个文字，可以加但是副作用挺大
                    // 运营部 - 3 - 柏慧（客户运营）(baih) 17:07:20
                    // 就只这个教程加，其他不加呢
                    // 开发四部 - 1 - 王雷(wanglei) 17:07:30
                    // 可以，也是我这里写死
                    // 运营部 - 3 - 柏慧（客户运营）(baih) 17:07:43
                    // 兴，那就写死吧
                    if (v.id == 10) {
                        arr.push('培训教程')
                    }
                    arr.push(v.name)
                    if (!v.isShow) break
                }
            }
            return arr
        },
        getPic(state) {
            return state.pImgUrlList
        },
        getProductAddress(state) {
            return state.softUrl
        }
    },
    actions: {},
    modules: {
        addbuy,
        newbuy,
        renewbuy,
        Order,
    }
})